import * as React from "react";
import { SVGProps } from "react";
function SvgSummaryLinkIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 5 7.5 7.5 4 10l3.5 2.5L11 15v-4h4V9h-4V5Zm-1-5C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z"
        fill="#5A9D86"
      />
    </svg>
  );
}
export default SvgSummaryLinkIcon;
